import { Component, Input } from 'ng-metadata/core';
import './social-engagement.scss';

/**
 * @ngdoc directive
 * @name mwContentDocumentSocialEngagement
 * @module mw.components.contentDocuments
 * @param {number} [replies] - The number of Twitter Replies
 * @param {number} [retweets] - The number of Twitter Retweets
 * @param {number} [likes] - The number of Twitter Likes
 * @param {number} [lastUpdatedAt] - last time engagement data is updated
 *
 * @description
 * `mw-content-document-social-engagement` is a component responsible for displaying a social document's engagement stats
 * @usage
 * <hljs hljs-language="html">
 *  <mw-content-document-social-engagement
 *      replies="document.socialScores.tw_replies"
 *      retweets="document.socialScores.tw_retweets"
 *      likes="document.socialScores.tw_likes"
 *      last-updated-at="document.engagementLastUpdateDate">
 *  </mw-content-document-social-engagement>
 * </hljs>
 */
@Component({
    selector: 'mw-content-document-social-engagement',
    template: `
        <div class="mw-content-document-social-engagement">
            <ul class="mw-content-document-social-engagement__list">
                <li class="mw-content-document-social-engagement__list-item">
                    {{::$ctrl.replies | mwTruncateNumber }}
                    <span translate>social-engagement--replies</span>
                </li>
                <li class="mw-content-document-social-engagement__list-item">
                    {{::$ctrl.retweets | mwTruncateNumber }}
                    <span translate>social_engagement--retweets</span>
                </li>
                <li class="mw-content-document-social-engagement__list-item">
                    {{::$ctrl.likes | mwTruncateNumber }}
                    <span translate>social_engagement--likes</span>
                </li>
                <li class="mw-content-document-social-engagement__list-item">
                    {{::$ctrl.lastUpdatedAt | mwTimestamp }}
                </li>
            </ul>
        </div>
    `
})

export class SocialEngagementComponent {
    @Input('<') replies: number|string = '--';
    @Input('<') retweets: number|string = '--';
    @Input('<') likes: number|string = '--';
    @Input('<') lastUpdatedAt: number;

}



// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-document/social-engagement/social-engagement.component.ts